// extracted by mini-css-extract-plugin
export default {"wrapper":"nB-z","button":"oB-z","alternate":"pB-z","disabled":"qB-z","paymentWarning":"rB-z","fadeIn":"sB-z"};